import { createSelector } from 'reselect';
import { IDENTITIES_REDUCER_KEY } from './identitiesReducer';

export const getIdentitiesStore = (state) => state[IDENTITIES_REDUCER_KEY];
export const getResourcesById = (state) => getIdentitiesStore(state).resourcesById;
export const getIsLoading = (state) => getIdentitiesStore(state).isLoading;
export const getLoadPending = (state) => getIdentitiesStore(state).loadPending;
export const getLastSyncDate = (state) => getIdentitiesStore(state).lastSyncDate;
export const getError = (state) => getIdentitiesStore(state).error;

export const getValidIdentities = createSelector(getResourcesById, (allIdentities) =>
  allIdentities.filter((identity) => identity.verificationStatus === 'VALID'),
);

export const getActiveIdentity = createSelector(
  getResourcesById,
  getValidIdentities,
  (allIdentities, validIdentities) =>
    validIdentities?.first() ? validIdentities.first() : allIdentities?.first() || null,
);
